export type EmployeeApiRole =
  | 'manager'
  | 'relationship_manager'
  | 'sales_executive';

export type EmployeeStatus =
  | 'active'
  | 'invited'
  | 'inactive'
  | 'deactivated';

export type EmployeeStatusFilter = EmployeeStatus | 'all';

const EMPLOYEE_STATUS_ALIASES: Record<string, EmployeeStatus> = {
  active: 'active',
  invited: 'invited',
  inactive: 'inactive',
  inactived: 'inactive',
  deactivated: 'deactivated',
};

export const normalizeEmployeeStatus = (
  status: string | null | undefined
): EmployeeStatus => {
  const key = status?.trim().toLowerCase() ?? '';
  return EMPLOYEE_STATUS_ALIASES[key] ?? 'inactive';
};

export const EMPLOYEE_STATUS_LABELS: Record<EmployeeStatus, string> = {
  active: 'Active',
  invited: 'Invited',
  inactive: 'Inactive',
  deactivated: 'Deactivated',
};

export const EMPLOYEE_ROLE_LABELS: Record<EmployeeApiRole, string> = {
  manager: 'Manager',
  relationship_manager: 'Relationship Executive',
  sales_executive: 'Sales Executive',
};

export interface Employee {
  id: number;
  uniqueId: string;
  firstName: string | null;
  lastName: string | null;
  email: string;
  phoneNumber: string;
  profilePictureUrl: string | null;
  role: string | null;
  department: string | null;
  status: EmployeeStatus;
  fullName?: string;
}

export interface EmployeeDetail {
  id: number;
  uniqueId: string;
  firstName: string;
  lastName: string;
  email: string;
  role: EmployeeApiRole;
  branchId: number;
  profilePictureId: number | null;
  status: EmployeeStatus;
}

export interface AssignableRole {
  name: EmployeeApiRole;
}

export interface CreateEmployeeRequest {
  firstName: string;
  lastName?: string;
  email: string;
  role: EmployeeApiRole;
  branchId: number;
  profilePictureId?: number;
  sendActivationEmail?: boolean;
}

export interface UpdateEmployeeRequest {
  firstName?: string;
  lastName?: string;
  email?: string;
  role?: EmployeeApiRole;
  branchId?: number;
  profilePictureId?: number;
}

export interface EmployeesQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  role?: string;
  branchId?: number;
  status?: string;
}

export interface SearchEmployeesRequest {
  page?: number;
  limit?: number;
  search?: string;
  role?: EmployeeApiRole;
  branchId?: number;
  status?: EmployeeStatus;
}
